const Consts = {
    _STORAGE_PREFIX: "ve__",
    STORAGE_NAME_TOKEN: "TOKEN",
    STORAGE_NAME_LOGIN$QQ$STATE: "LOGIN_QQ_STATE",
    STORAGE_NAME_LOGIN$QQ$RESULT: "LOGIN_QQ_RESULT",
    STORAGE_NAME_REDIRECT$URL: "REDIRECT_URL",
    STORAGE_NAME_SETTING: "SETTING"
};

for (let key in Consts) {
    if (key.startsWith("STORAGE_")) {
        Consts[key] = Consts._STORAGE_PREFIX + Consts[key];
    }
}

export default Consts;